module.exports = __webpack_public_path__ + "img/icon-data-picker-remove.9767eef2.svg";